import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import ReactToPrint from "react-to-print";
import { useDispatch, useSelector } from "react-redux";
import Dialog from "../Dialog-Box/dialog";
import SelectedRowsPrint from "../../Print/selectedRowsPrint";
import { currency } from "../currencyFormatterTag";
import { openSnackbar } from "../../../Redux/Actions/snackbarActions";
import { pageStyle } from "../../Print/printPagesStyles";
import { alpha } from "@mui/material/styles";
import {
  Button,
  Checkbox,
  FormControlLabel,
  IconButton,
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import {
  AddCircle,
  Delete,
  Edit,
  FindReplace,
  Print,
  Visibility,
} from "@mui/icons-material";
import Reports from "Components/Print/a4-report-print";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from '@mui/icons-material/LockOpen';
import { AUTH_ROLES } from "Components/Constants/AuthRoles";
import { Form, Formik } from "formik";
import FormControl from "../FormControl/fomikFormControl";
import { LOCAL_STORAGE } from "Components/Constants/LocalStorage";
import customerService from "Service/Customer/customer.service";
import DriveFileMoveIcon from "@mui/icons-material/DriveFileMove";


const TableView = (props) => {
  const {
    title,
    titleTwo,
    headCells,
    service,
    noAdding,
    AddComponent,
    editable,
    deletable,
    actions,
    searchable,
    MoveToLedger,
    LedgerComponent,
    ViewComponent,
    dialogBoxWidth,
    AddComponentTwo,
    customService,
    lockable,
    periodicSearch,
    withoutLocationFilter,
    sendSms,
    productSmsStatus,
    AddOptionHide,
    ...rest
  } = props;
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formSubmitted, setFromSubmitted] = useState(false);
  const [ledgerOpen, setLedgerOpen] = useState(false);

  const [searchSubmitted, setSearchSubmitted] = useState(false);
  const [openTwo, setOpenTwo] = useState(false);

  const dispatch = useDispatch();
  const tableTopRef = useRef(null);
  const user = useSelector((state) => state.auth);
  const [open, setOpen] = useState(false);
  const [viewOpen, setViewOpen] = useState(false);
  const [EditOpen, setEditOpen] = useState(false);
  const [Search, setSearch] = useState("");
  const [lockAble,setLockable] = useState(true)

  let locationCode = JSON.parse(localStorage.getItem(LOCAL_STORAGE.BIZX_LOCATION)).code;

  var date = new Date();
  var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    .toISOString()
    .split("T")[0];
  const today = date.toISOString().split("T")[0];

  const fetchTableRows = async (searchVal) => {
    setData([]);
    setLoading(true);
    try {
      const results =
        searchVal && searchVal !== ""
          ? await service.search(searchVal)
          : customService ? await customService : await service.getAll();

      const locationFilterdData = results.filter((row)=>row.stockLocationCode == locationCode);    
      withoutLocationFilter ? setData(results) : setData(locationFilterdData);
      setSelected([]);
      setLockable(
        data.map((row)=>row.isLocked == 1 ? false : true)
      )
// console.log(results.filter);
    } catch (e) {
      dispatch(openSnackbar(true, "error", e.message));
    }
    setLoading(false);
  };

  const handlePeriodicSearch = async (values) => {
    setLoading(true);
    const { customer, fromDate, toDate } = values;
    try {
      const res = await service.periodicSearch(
        fromDate,
        toDate
      );
      setData(res); 
    } catch (e) {
      dispatch(openSnackbar(true, "error", e));
    }
    setLoading(false);
  };
  
  const handleDelete = async (code, setSelected) => {
    try {
      await service.delete(code);
      fetchTableRows();
      setSelected([]);
      dispatch(openSnackbar(true, "success", `Deleted successfully`));
    } catch (e) {
      dispatch(openSnackbar(true, "error", e));
    }
  };

  const handleLock = async (code, setSelected) => {
    try {
      // Check if there is a row with code[0] and isLocked === 1
      const isLockedRow = data.find((row) => row.code === code[0] && row.isLocked == 1);

      if (isLockedRow !== undefined) {
        // Show an alert if the row is already locked
        alert(`This ${title} is Already Locked`);
      } else {
        // If not locked, proceed with locking the GRN
        await service.lock({ code: code[0] });
        fetchTableRows();
        setSelected([]);
        dispatch(openSnackbar(true, "success", "Lock successfully"));
      }
    } catch (e) {
      dispatch(openSnackbar(true, "error", e));
    }
  };




  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    fetchTableRows();
    return () => {
      controller.abort();
    };

  }, [formSubmitted]);

  const handleSearch = (e) => {
    if (e.key === "Enter") {
      setSearchSubmitted(Search);
      fetchTableRows(Search);
      setPage(0);
    } else if (e.key === "Escape") {
      setSearch("");
      fetchTableRows();
      setSearchSubmitted(false);
    }
  };
  //-----------------------------
  // const [productStatus1,setProductStatus1] = useState(false);
  // const [productStatus2,setProductStatus2] = useState(false);
  // const [productStatus3,setProductStatus3] = useState(false);
//---------------sms-----------
const [services,setServices] = React.useState({
  rows:[],
  loading: false,
});
const sms = async ()=> {
  try {
    let response = await customerService.sendSms({customer:selected});
    setServices(response);
    dispatch(openSnackbar(true, "success", "SMS sent successfully"));
  } catch (e) {
    dispatch(openSnackbar(true, "error", e));
  }
};

//--------------endSms--------------------
const [smsStatus,setSmsStatus] = React.useState({
  rows:[],
  loading: false,
});
// const productStatus1 = async (productStatus)=> {
//   try {
//     let response = await customerService.sendproductStatus({customer:selected,productStatus});
//     setSmsStatus(response);
//     dispatch(openSnackbar(true, "success", "Product status updated successfully"));
//   } catch (e) {
//     dispatch(openSnackbar(true, "error", e));
//   }
// };
const productStatus = async ({customer:selected, status}) => {
  const values = { customer:selected, status };
  try {
    await customerService.sendproductStatus(values);
    dispatch(openSnackbar(true, "success", "Product status updated successfully"));
  } catch (e) {
    dispatch(openSnackbar(true, "error", e.message));
  }
};
//-----------------------------
  function EnhancedTableHead(props) {
    const { onSelectAllClick, numSelected, rowCount } = props;

    return (
      <TableHead style={{ backgroundColor: "#eee" }}>
        <TableRow>
          <TableCell padding="checkbox">
            <Checkbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={rowCount > 0 && numSelected === rowCount}
              onChange={onSelectAllClick}
              inputProps={{ "aria-label": "select all" }}
            />
          </TableCell>
          {headCells.map((headCell, index) => (
            <TableCell
              key={index}
              align={headCell.numeric ? "right" : "left"}
              padding={headCell.disablePadding ? "none" : "normal"}
              width={headCell.width}
            >
              <TableSortLabel>{headCell.label}</TableSortLabel>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }

  EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    rowCount: PropTypes.number.isRequired,
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

   const handleClickOpenTwo = () => {
    setOpenTwo(true);
  };
  const EnhancedTableToolbar = (props) => {
    const { numSelected } = props;
    const componentRef = useRef();
    return (
      <>
    <div ref={tableTopRef}></div>
      <div className="space-between mb" style={{ width: "100%" }}></div>
        <Toolbar
          sx={{
            pl: { sm: 2 },
            pr: { xs: 1, sm: 1 },
            ...(numSelected > 0 && {
              bgcolor: (theme) =>
                alpha(
                  theme.palette.primary.main,
                  theme.palette.action.activatedOpacity
                ),
            }),
          }}
        >
          {numSelected > 0 && (
            <>
              <Typography
                sx={{ flex: "1 1 100%" }}
                marginRight={3}
                color="inherit"
                variant="subtitle1"
                component="div"
              >
                {numSelected} selected
              </Typography>
                {MoveToLedger && (
                <>
                  <Tooltip title="Move to ledger">
                    <IconButton
                      onClick={() => {
                        setLedgerOpen(true);
                      }}
                      aria-label="Edit"
                    >
                      <DriveFileMoveIcon color="success" />
                    </IconButton>
                  </Tooltip>
                  <Dialog
                    //maxWidth={dialogBoxWidth ? dialogBoxWidth : "md"}
                    open={ledgerOpen}
                    setOpen={setLedgerOpen}
                    title="Move To Legger"
                  >
                    <LedgerComponent
                      setSubmitted={setFromSubmitted}
                      setOpen={setLedgerOpen}
                      code={selected}
                      {...rest}
                    />
                  </Dialog>
                </>
              )}
              {numSelected === 1 && (
                <>
                    <>
                   {productSmsStatus && (
                    <>
                    <Button
              variant="contained"
              color="primary"
              onClick={() => productStatus("start")}
            >
              Start
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => productStatus("work done")}
            >
              Work Done
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => productStatus("ready to take")}
            >
              Ready to Take
            </Button>
                    </>
                   )}
                      {lockable && (
                        <Tooltip title="Lock">
                          <IconButton
                            onClick={() => {
                              if (window.confirm("Are you sure want to lock this?")) {
                                selected.length === 1 && handleLock(selected, setSelected);
                              }
                            }}
                            aria-label="Lock"
                          >
                            <LockOpenIcon />
                          </IconButton>
                        </Tooltip>
                      )}


                      {editable &&  (
                        <>
                          <Tooltip title="Edit">
                            <IconButton
                              onClick={() => {
                               if(data.find((row) => row.code == selected[0] && row.isLocked == 1)) {
                                alert(`This ${title} is Already Locked`);
                               } else
                                setEditOpen(true);
                              }}
                              aria-label="Edit"
                            >
                              <Edit />
                            </IconButton>
                          </Tooltip>
                          <Dialog
                            maxWidth={dialogBoxWidth ? dialogBoxWidth : "md"}
                            open={EditOpen}
                            setOpen={setEditOpen}
                            title={`Edit ${title === undefined ? "" : title}`}
                          >
                            <AddComponent
                              setSubmitted={setFromSubmitted}
                              code={selected.length === 1 ? selected : null}
                              setOpen={setEditOpen}
                              {...rest}
                            />
                          </Dialog>
                        </>
                      )}

                       {AddComponentTwo && !noAdding && (
              <>
                {/* <Button
                  variant="contained"
                  color="primary"
                  startIcon={<AddCircle />}
                  onClick={handleClickOpenTwo}
                  style={{ borderRadius: 35 }}
                >
                  ADD {titleTwo}
                </Button> */}

                <Dialog
                  maxWidth={dialogBoxWidth ? dialogBoxWidth : "md"}
                  open={openTwo}
                  setOpen={setOpenTwo}
                  title={`ADD ${titleTwo === undefined ? "" : titleTwo}`}
                >
                  <AddComponentTwo
                    setSubmitted={setFromSubmitted}
                    setOpen={setOpenTwo}
                    {...rest}
                  />
                </Dialog>
              </>
            )}


                    </>

                  {deletable && (
                    <>
                      <Tooltip title="Delete">
                        <IconButton
                          onClick={() => {
                            if (
                              window.confirm(
                                "Are you sure want to delete this?"
                              )
                            )
                              selected.length === 1 &&
                                handleDelete(selected, setSelected);
                          }}
                          aria-label="Edit"
                        >
                          <Delete />
                        </IconButton>
                      </Tooltip>
                    </>
                  )}
                  {ViewComponent && (
                    <div>
                      <Tooltip title="View">
                        <IconButton
                          onClick={() => {
                            setViewOpen(true);
                          }}
                          aria-label="View"
                        >
                          <Visibility />
                        </IconButton>
                      </Tooltip>
                      <Dialog
                        fullScreen
                        open={viewOpen}
                        setOpen={setViewOpen}
                        title={`${title === undefined ? "" : title} View`}
                      >
                        <ViewComponent
                          code={selected.length === 1 ? selected : null}
                          pageStyle={pageStyle.a4}
                          setViewOpen={setViewOpen}
                          setSubmitted={setFromSubmitted}
                          
                        />
                      </Dialog>
                    </div>
                  )}
                </>
              )}
              {actions?.map((action, i) => (
                <>
                  <Tooltip title={action.name} key={i}>
                    <IconButton
                      onClick={async (event) => {
                        await action.callBack(event, selected);
                        fetchTableRows();
                      }}
                      aria-label={action.name}
                    >
                      {action.icon}
                    </IconButton>
                  </Tooltip>
                </>
              ))}
              <ReactToPrint
                trigger={() => (
                  <Tooltip title="Print">
                    <IconButton aria-label="Print">
                      <Print />
                    </IconButton>
                  </Tooltip>
                )}
                content={() => componentRef.current}
                pageStyle={pageStyle.a4}
                documentTitle={`${title} report`}
              />
              <div style={{ display: "none" }}>
                <div ref={componentRef}>
                  <Reports title={`${title} Information`}>
                    <SelectedRowsPrint
                      code={selected}
                      headCells={headCells}
                      rows={data}
                    />
                  </Reports>
                </div>
              </div>
            </>
          )}
        </Toolbar>
      </>
    );
  };

  EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
  };

  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = data.map((n) => n.code);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, code) => {
    const selectedIndex = selected.indexOf(code);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, code);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

const handleChangePage = (event, newPage) => {
  setPage(newPage);
};

useEffect(() => {
  if (tableTopRef.current) {
    tableTopRef.current.scrollIntoView({ behavior: 'smooth' });
  }
}, [rowsPerPage]);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    if (tableTopRef.current) {
      tableTopRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);

  return (
    <>
      <div>
        <div className="space-between mb" style={{ width: "100%" }}>
          {AddComponent && !noAdding && (
            <>
            {AddOptionHide ? ("") : (
               <Button
               variant="contained"
               color="primary"
               startIcon={<AddCircle />}
               onClick={handleClickOpen}
               style={{ borderRadius: 35 }}
             >
               Add {title} 
             </Button>
            )}
             

              <Dialog
                maxWidth={dialogBoxWidth ? dialogBoxWidth : "md"}
                open={open}
                setOpen={setOpen}
                title={`Add ${title === undefined ? "" : title}`}
              >
                <AddComponent
                  setSubmitted={setFromSubmitted}
                  setOpen={setOpen}
                  {...rest}
                />
              </Dialog>
            </>
          )}

          {AddComponentTwo && !noAdding && (
              <>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<AddCircle />}
                  onClick={handleClickOpenTwo}
                  style={{ borderRadius: 35 }}
                >
                  {titleTwo}
                </Button>

                <Dialog
                  maxWidth={dialogBoxWidth ? dialogBoxWidth : "md"}
                  open={openTwo}
                  setOpen={setOpenTwo}
                  title={`ADD ${titleTwo === undefined ? "" : titleTwo}`}
                >
                  <AddComponentTwo
                    setSubmitted={setFromSubmitted}
                    setOpen={setOpenTwo}
                    {...rest}
                  />
                </Dialog>
              </>
            )}

          {searchable && (
            <div className="flex">
              <input
                type="txt"
                value={Search}
                className="custom-search"
                placeholder="Search.."
                onKeyUp={handleSearch}
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
              />

              <button
                className="custom-btn"
                onClick={() => {
                  setSearch("");
                  fetchTableRows();
                  setSearchSubmitted(false);
                }}
              >
                <FindReplace color="primary" />
              </button>
            </div>
          )}
        </div>
        {searchSubmitted && (
          <p style={{ textAlign: "center", marginBottom: 5 }}>
            Search result of{" "}
            <span style={{ color: "crimson" }}>"{searchSubmitted}"</span>{" "}
            <span
              onClick={() => {
                setSearch("");
                fetchTableRows();
                setSearchSubmitted(false);
              }}
              style={{
                color: "blue",
                textDecoration: "underline",
                cursor: "pointer",
              }}
            >
              Clear it
            </span>
          </p>
        )}
        {sendSms &&(
         <div className="flex">
          <Button   color="primary" variant="contained" style={{ margin: 5 }} 
            onClick={() => {
              sms();
            }}
          >
            Sms</Button>
        </div>)}
        <div>

        {periodicSearch && (
          <Formik
          initialValues={{
            customer: "",
            fromDate: firstDay,
            toDate: today,
          }}
          onSubmit={handlePeriodicSearch}
        >
          {(props) => {
            return (
              <Form>
                <div className="flex mt mb">
                  <div className="col-3">
                    <FormControl
                      control="input"
                      type="date"
                      name="fromDate"
                      size="small"
                      label="From"
                      inputProps={{
                        max: today,
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </div>
                  <div className="col-3">
                    <FormControl
                      control="input"
                      type="date"
                      name="toDate"
                      size="small"
                      label="To"
                      inputProps={{
                        max: today,
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </div>
                  <div className="col-1">
                    <Button
                      variant="contained"
                      type="submit"
                      color="primary"
                      disabled={props.isSubmitting}
                    >
                      Find
                    </Button>
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
        ) }

          {selected.length > 0 && (
            <EnhancedTableToolbar numSelected={selected.length} title={title} />
          )}
          <div ref={tableTopRef}></div>
          <Paper>
            <TableContainer>
              <Table
                aria-labelledby="tableTitle"
                size={dense ? "small" : "medium"}
                aria-label="enhanced table"
              >
                <EnhancedTableHead
                  numSelected={selected.length}
                  onSelectAllClick={handleSelectAllClick}
                  rowCount={data.length}
                />

                <TableBody>
                  {data && data
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => {
                      const isItemSelected = isSelected(row.code);
                      const labelId = `enhanced-table-checkbox-${index}`;

                      return (
                        <React.Fragment key={index}>
                          <TableRow
                            hover
                            onClick={(event) => handleClick(event, row.code)}
                            role="checkbox"
                            aria-checked={isItemSelected}
                            tabIndex={-1}
                            selected={isItemSelected}
                          >
                            <TableCell padding="checkbox">
                              <Checkbox
                                checked={isItemSelected}
                                inputProps={{ "aria-labelledby": labelId }}
                              />
                            </TableCell>
                            {headCells.map((cell, index) => {
                              return (
                                <TableCell
                                  key={index}
                                  align={cell.numeric ? "right" : "left"}
                                  padding={
                                    cell.disablePadding ? "none" : "normal"
                                  }
                                  style={{
                                    backgroundColor: cell.color
                                      ? cell.id(row) > 0
                                        ? "#E41A1C70"
                                        : "#4DAF4A70"
                                      : "#fff",
                                  }}
                                >
                                  {cell.id(row) !== null
                                    ? cell.numeric
                                      ? currency(cell.id(row))
                                      : cell.id(row)
                                    : " - "}
                                </TableCell>
                              );
                            })}
                          </TableRow>
                        </React.Fragment>
                      );
                    })}
                  {data.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={headCells.length + 1} align="center">
                        {loading === true
                          ? "Loading..."
                          : `No ${title} to display.`}
                      </TableCell>
                    </TableRow>
                  )}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
                      <TableCell colSpan={headCells.length + 1} />
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 100, { label: 'All', value: 9999999999999 }]}
            component="div"
            count={data.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
          <FormControlLabel
            control={<Switch checked={dense} onChange={handleChangeDense} />}
            label="Dense padding"
          />
        </div>
      </div>
    </>
  );
};
export default TableView;
